import { PRIMARY } from "@constants/colors"

const containerWidth = {
  backgroundColor: "white",
  width: "100%"
}

const headerAvatar = {
  width: 40,
  height: 40,
  backgroundColor: `${PRIMARY}1a`,
  color: PRIMARY
}

const typeSelector = {
  "& .MuiToggleButton-root": {
    textTransform: "none",
    px: 2,
    py: 0.75,
    fontWeight: 600,
    borderColor: "divider"
  }
}

const contextCard = {
  p: 2,
  borderRadius: 2,
  backgroundColor: "grey.50"
}

const fieldWidth = {
  minWidth: 260,
  flex: "1 1 260px",
  backgroundColor: "white"
}

const chatContainer = {
  display: "flex",
  flexDirection: "column",
  borderRadius: 2,
  overflow: "hidden"
}

const chatHeader = {
  px: 2,
  py: 1.25,
  backgroundColor: "grey.50"
}

const aiAvatar = {
  width: 36,
  height: 36,
  backgroundColor: `${PRIMARY}1a`,
  color: PRIMARY
}

const statusDot = {
  width: 7,
  height: 7,
  borderRadius: "50%",
  backgroundColor: "success.main"
}

const messagesArea = {
  flex: 1,
  minHeight: 360,
  maxHeight: 480,
  overflowY: "auto",
  px: 2,
  py: 2,
  backgroundColor: "background.paper"
}

const emptyState = {
  height: "100%",
  minHeight: 320,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  color: "text.secondary"
}

const messageRow = {
  display: "flex",
  alignItems: "flex-start",
  width: "100%",
  gap: 1,
  mb: 1.5
}

const userMessageRow = {
  ...messageRow,
  flexDirection: "row-reverse",
  justifyContent: "flex-start"
}

const assistantMessageRow = {
  ...messageRow,
  justifyContent: "flex-start"
}

const bubbleAvatarAi = {
  width: 28,
  height: 28,
  backgroundColor: `${PRIMARY}1a`,
  color: PRIMARY
}

const bubbleAvatarUser = {
  width: 28,
  height: 28,
  backgroundColor: "grey.300",
  color: "grey.700"
}

const userBubble = {
  backgroundColor: PRIMARY,
  color: "white",
  borderRadius: "14px 14px 2px 14px",
  px: 1.75,
  py: 1,
  maxWidth: "100%",
  boxShadow: "none"
}

const assistantBubble = {
  backgroundColor: "grey.100",
  color: "text.primary",
  borderRadius: "14px 14px 14px 2px",
  px: 1.75,
  py: 1,
  maxWidth: "100%"
}

const messageContentColumn = {
  display: "inline-flex",
  flexDirection: "column",
  flex: "0 1 auto",
  width: "fit-content",
  maxWidth: "68%"
}

const inputRow = {
  px: 1.5,
  py: 1.25,
  backgroundColor: "background.paper"
}

const pillInput = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 999,
    backgroundColor: "grey.50"
  }
}

const sendButtonEnabled = {
  backgroundColor: PRIMARY,
  color: "white",
  "&:hover": {
    backgroundColor: PRIMARY
  }
}

const sendButtonDisabled = {
  backgroundColor: "grey.100",
  color: "grey.400"
}

const userMessageActions = {
  display: "flex",
  justifyContent: "flex-end",
  mt: 0.25,
  minHeight: 20,
  width: "100%"
}

const assistantMessageActions = {
  display: "flex",
  justifyContent: "flex-start",
  mt: 0.25,
  minHeight: 20,
  width: "100%"
}

const messageActionButton = {
  color: "text.secondary",
  fontSize: 16,
  p: 0.25
}

const noAccessCard = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1,
  p: 5,
  borderRadius: 2,
  backgroundColor: "grey.50"
}

export default {
  containerWidth,
  headerAvatar,
  typeSelector,
  contextCard,
  fieldWidth,
  chatContainer,
  chatHeader,
  aiAvatar,
  statusDot,
  messagesArea,
  emptyState,
  userMessageRow,
  assistantMessageRow,
  bubbleAvatarAi,
  bubbleAvatarUser,
  userBubble,
  assistantBubble,
  messageContentColumn,
  inputRow,
  pillInput,
  sendButtonEnabled,
  sendButtonDisabled,
  userMessageActions,
  assistantMessageActions,
  messageActionButton,
  noAccessCard
}
